import { AvatarPerson } from "#webapp/src/components/avatar";
import { AvatarPerson as AvatarPersonType } from "#webapp/src/components/avatar/AvatarTypes";
import { Close } from "@clockwise/design-system/icons";
import { IconButton } from "@material-ui/core";
import * as React from "react";

export interface IProps {
  person: AvatarPersonType | null;
  email: string;
  onClose: () => void;
  onAvatarClick?: () => void;
}

export const ChromeMenuHeader = ({ person, email, onClose, onAvatarClick }: IProps) => {
  // Use email as a fallback if person is missing or both names are empty
  const givenName = person?.profile?.givenName ?? "";
  const familyName = person?.profile?.familyName ?? "";
  const displayName = givenName || familyName ? `${givenName} ${familyName}` : email;

  return (
    <div className="cw-bg-accent-emphasis cw-p-4">
      <IconButton
        className="cw-absolute cw-right-0 cw-top-0"
        onClick={onClose}
        cw-id="menu-close-button"
      >
        <Close className="cw-text-onEmphasis" />
      </IconButton>
      <AvatarPerson
        person={person}
        orgPerson={null}
        size="large"
        backupCalendarId={email}
        onClick={onAvatarClick}
        showUserBadge
      />
      <div
        className="cw-heading-base cw-text-onEmphasis cw-mt-4 cw-mb-1 cw-truncate"
        cw-id="menu-user-name"
      >
        {displayName}
      </div>
      <div className="cw-body-base cw-text-onEmphasis cw-truncate" cw-id="menu-user-email">
        {email}
      </div>
    </div>
  );
};
